// Engineering Letters

(function ($) {

    /**
     * Checked subscriptions and email address
     *
     * @type {{}}
     */
    let toSendData = {};

    /**
     * Class EngineerLetters
     *
     * @param options
     * @constructor
     */
    function EngineerLetters(options) {
        if (!options) {
            throw new Error('No options passed to EngineerLetters constructor');
        } else if (!options.apiHost) {
            throw new Error('ApiHost host option is not passed to EngineerLetters constructor');
        } else if (!options.nonce) {
            throw new Error('Nonce option is not passed to EngineerLetters constructor');
        }

        this.options = $.extend({}, EngineerLetters.defaults, options);
        this.setup();
    }

    /**
     * Set events
     */
    EngineerLetters.prototype.setup = function () {
        let self = this;

        // Add or remove subscriptions from list
        $(document).on('change', '.letter-cards input[type="checkbox"]', function (event) {
            self.checkSubscriptions(event);
        });

        // Subscribe
        $('#engineer-letters-subscriptions').on('submit', function (event) {
            toSendData.email = $('#std-form-popup-input-email').val();
            event.preventDefault();
            self.checkSubscriptions();
            self.sendSubscriptionData();
        });
    };

    /**
     * Check subscriptions checkboxes and add subscriptions to subscription list
     *
     * @param event
     */
    EngineerLetters.prototype.checkSubscriptions = function (event) {
        toSendData['subscriptionIDs'] = [];
        $('.letter-cards input[type="checkbox"]').each(function (key, value) {
            let checkbox = $(value);
            if (checkbox.is(':checked')) {
                toSendData.subscriptionIDs.push(checkbox.data('subscription-id'));
                checkbox.closest('.letter-cards__item').addClass('added');
            } else {
                checkbox.closest('.letter-cards__item').removeClass('added');
            }
        });
    };

    /**
     * Send subscription data
     */
    EngineerLetters.prototype.sendSubscriptionData = function () {
        if (!this.validate()) {
            return;
        }

        let self = this;
        $.ajax({
            type: 'post',
            url: self.options.apiHost,
            data: toSendData,
            dataType: 'json',
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
                self.disableInputs();
                self.hideMessage();
            },
            success: function (response) {
                self.enableInputs();
                self.showMessage('success', response.message);
                self.resetForm();
            },
            error: function (data, status, message) {
                self.enableInputs();
                self.showMessage('error', data.responseJSON.message);
            }
        });
    };

    /**
     * Validating fields before sending
     *
     * @returns {boolean}
     */
    EngineerLetters.prototype.validate = function () {
        let isSomeSubscriptionCheckboxIsChecked = $('.letter-cards input[type="checkbox"]').is(':checked');
        if (!isSomeSubscriptionCheckboxIsChecked) {
            this.hideMessage();
            this.showMessage('error', 'Выберите одну из подписок');
            return false;
        }

        return true;
    }

    /**
     * Disable inputs
     */
    EngineerLetters.prototype.disableInputs = function () {
        let submitButton = $('#engineer_submit_button');
        submitButton.addClass('engineering-content__btn--disabled');
        submitButton.prop('disabled', true);
        $('.engineering-content').find('input, button').prop('disabled', true);
    }

    /**
     * Enable inputs
     */
    EngineerLetters.prototype.enableInputs = function () {
        let submitButton = $('#engineer_submit_button');
        submitButton.removeClass('engineering-content__btn--disabled');
        submitButton.prop('disabled', false);
        $('.engineering-content').find('input, button').prop('disabled', false);
    }

    /**
     * Hide message
     */
    EngineerLetters.prototype.hideMessage = function () {
        let messageBlock = $('#message-block');
        messageBlock.empty().hide();
        messageBlock.removeClass('engeneering-content__validate--success');
        messageBlock.removeClass('engeneering-content__validate--required');
        messageBlock.removeClass('engeneering-content__validate--error');
    }

    /**
     * Show message
     *
     * @param status - message status. Available statuses: success, required, error.
     * @param message - message
     */
    EngineerLetters.prototype.showMessage = function (status, message) {
        let messageBlock = $('#message-block');
        let statusClass = 'engeneering-content__validate--' + status;

        messageBlock.append(message).addClass(statusClass).show();
    }

    EngineerLetters.prototype.resetForm = function () {
        $('.engineering-content input:checkbox').prop('checked', false).closest('.letter-cards__item').removeClass('added');
        $('#std-form-popup-input-email').val('');
    }

    window.EngineerLetters = EngineerLetters;

})(jQuery);
